import { PaymentConfig } from '../../_core/types/theme/Payment.type';

const payment: PaymentConfig = {
  history: {
    seo: {
      title: 'Payment History - MysticWork',
      description: '',
    },
  },
  success: {
    seo: {
      title: 'Payment confirmation - MysticWork',
      description: '',
    },
  },
  fail: {
    seo: {
      title: 'Payment failed - MysticWork',
      description: '',
    },
  },
  thankYou: {
    seo: {
      title: 'Thank you - MysticWork',
      description: '',
    },
  },
};

// @ts-ignore
export default payment;
